import Vue from 'vue'
import TurbolinksAdapter from 'vue-turbolinks'

document.addEventListener('turbolinks:load', () => {
  const el = document.querySelector('.vue-mobile-menu')
  if (el) {
    const alert = new Vue({
      el,
      mixins: [TurbolinksAdapter],
      data: {
        isOpen: false
      }
    })
  }
})



// WEBPACK FOOTER //
// ./app/javascript/packs/components/mobile_menu.js